
        
    const runtime = require("../../../../../../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
    
        
            __nunjucks_module_dependencies__.templates["lib/loading/views/templates/loading-view.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "message")) {
output += "\n<div class=\"message\">\n  <h3>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "message"), env.opts.autoescape);
output += "</h3>\n</div>\n";
;
}
output += "\n\n<div class=\"step\">\n  <div class=\"bar\"></div>\n  <div class=\"dot dot-1\"></div>\n  <div class=\"dot dot-2\"></div>\n  <div class=\"dot dot-3\"></div>\n  <div class=\"dot dot-4\"></div>\n  <div class=\"dot dot-5\"></div>\n</div>\n<div class=\"step\">\n  <div class=\"bar\"></div>\n  <div class=\"dot dot-1\"></div>\n  <div class=\"dot dot-2\"></div>\n  <div class=\"dot dot-3\"></div>\n  <div class=\"dot dot-4\"></div>\n  <div class=\"dot dot-5\"></div>\n</div>\n<div class=\"step\">\n  <div class=\"bar\"></div>\n  <div class=\"dot dot-1\"></div>\n  <div class=\"dot dot-2\"></div>\n  <div class=\"dot dot-3\"></div>\n  <div class=\"dot dot-4\"></div>\n  <div class=\"dot dot-5\"></div>\n</div>\n<div class=\"step\">\n  <div class=\"bar\"></div>\n  <div class=\"dot dot-1\"></div>\n  <div class=\"dot dot-2\"></div>\n  <div class=\"dot dot-3\"></div>\n  <div class=\"dot dot-4\"></div>\n  <div class=\"dot dot-5\"></div>\n</div>\n<div class=\"step\">\n  <div class=\"bar\"></div>\n  <div class=\"dot dot-1\"></div>\n  <div class=\"dot dot-2\"></div>\n  <div class=\"dot dot-3\"></div>\n  <div class=\"dot dot-4\"></div>\n  <div class=\"dot dot-5\"></div>\n</div>\n<div class=\"step\">\n  <div class=\"bar\"></div>\n  <div class=\"dot dot-1\"></div>\n  <div class=\"dot dot-2\"></div>\n  <div class=\"dot dot-3\"></div>\n  <div class=\"dot dot-4\"></div>\n  <div class=\"dot dot-5\"></div>\n</div>\n<div class=\"step\">\n  <div class=\"bar\"></div>\n  <div class=\"dot dot-1\"></div>\n  <div class=\"dot dot-2\"></div>\n  <div class=\"dot dot-3\"></div>\n  <div class=\"dot dot-4\"></div>\n  <div class=\"dot dot-5\"></div>\n</div>\n<div class=\"step\">\n  <div class=\"bar\"></div>\n  <div class=\"dot dot-1\"></div>\n  <div class=\"dot dot-2\"></div>\n  <div class=\"dot dot-3\"></div>\n  <div class=\"dot dot-4\"></div>\n  <div class=\"dot dot-5\"></div>\n</div>\n<div class=\"step\">\n  <div class=\"bar\"></div>\n  <div class=\"dot dot-1\"></div>\n  <div class=\"dot dot-2\"></div>\n  <div class=\"dot dot-3\"></div>\n  <div class=\"dot dot-4\"></div>\n  <div class=\"dot dot-5\"></div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "lib/loading/views/templates/loading-view.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "lib/loading/views/templates/loading-view.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["lib/loading/views/templates/loading-view.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    